// @flow

import * as Immutable                          from 'immutable';
import * as React                              from 'react';
import connect                                 from 'react-redux/lib/connect/connect';
import Link                                    from 'react-router-dom/Link';
import * as Reactstrap                         from 'reactstrap';
import * as Recompose                          from 'recompose';
import clearCookieNotAllowedModal              from '../../../actions/cookieSettings/clearCookieNotAllowedModal';
import updateUserCookieSettings                from '../../../actions/cookieSettings/updateUserCookieSettings';
import type {
  CookieType,
  CookieTypeConfig,
}                                              from '../../../config/cookiesConfig';
import cookiesConfig                           from '../../../config/cookiesConfig';
import routes                                  from '../../../config/routes';
import Button                                  from '../../../modules/reactstrap/components/Button';
import { selectCookieBlockedModalCookieTypes } from '../../../selectors/cookieSettingsSelectors';
import getCookieTypeConfigHash                 from '../../../utils/cookieSettings/getCookieTypeConfigHash';
import AcceptAllCookiesButton                  from './AcceptAllCookiesButton';


// -----------------------------------------------------------------------------------------------------------------
// Presentation component
// -----------------------------------------------------------------------------------------------------------------

export type CookieNotAllowedModalProps = {|
  cookieTypes: Immutable.List<CookieType>,
  onAllow: () => void,
  clearCookieModal: () => void,
  className?: string,
|};

let CookieNotAllowedModal: React.ComponentType<CookieNotAllowedModalProps> =
      ({cookieTypes, clearCookieModal, className}) => {
        const isMultipleTypes: boolean = cookieTypes.count() > 1;

        return <Reactstrap.Modal isOpen toggle={clearCookieModal} className={className}>
          <Reactstrap.ModalHeader toggle={clearCookieModal}>
            We need your permission to store data
            locally</Reactstrap.ModalHeader>
          <Reactstrap.ModalBody>
            <p>Sorry, but this functionality will not work as it requires that you grant permission to save the
              following data...</p>

            <ul>
              {React.Children.toArray(
                cookieTypes.map((cookieType: CookieType) => <li>{cookiesConfig[cookieType].title}</li>),
              )}

            </ul>

            <p>Please revisit the <Link to={routes.COOKIES_SETTINGS.compile()} onClick={clearCookieModal}>Cookies and
              Local Storage settings page</Link> and review the details of {isMultipleTypes ? 'these' : 'this'} data
              type{isMultipleTypes ? 's' : ''}, and if you are happy to allow, accept {isMultipleTypes ? 'these' :
                'this'} additional types.</p>

            <p>If not, then you may not use this functionality of the site.</p>

            <p>Alternatively, you could click 'Accept all' button below to allow the storing of all data types, meaning
              you won't be prompted again.</p>
          </Reactstrap.ModalBody>
          <Reactstrap.ModalFooter>
            <AcceptAllCookiesButton onClick={clearCookieModal}/>
            {' '}
            <Button color="primary" to={routes.COOKIES_SETTINGS.compile()} onClick={clearCookieModal}>Go to cookie
              settings</Button>
          </Reactstrap.ModalFooter>
        </Reactstrap.Modal>;
      };


CookieNotAllowedModal = Recompose.compose(
  connect(
    (state) => ({
      cookieTypes: selectCookieBlockedModalCookieTypes(state),
    }),
    (dispatch) => ({
      clearCookieModal: () => dispatch(clearCookieNotAllowedModal()),
    }),
  ),

  Recompose.branch(
    props => props.cookieTypes.isEmpty(),
    Recompose.renderNothing,
  ),
)(CookieNotAllowedModal);


export default CookieNotAllowedModal;



// WEBPACK FOOTER //
// ./src/components/profile/cookies/CookieNotAllowedModal.js